export default EnergyPriceLevels;

function EnergyPriceLevels(vat = 1) {
  let priceLevels = {};
const basePriceLevels = {"low":"50","medium":"110","concerning":"130","high":"150"};

  for (let key in basePriceLevels) {
    priceLevels[key] = Math.round((basePriceLevels[key] * vat) / 10) * 10;
  }

  return priceLevels;
}
